
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BasicInfoForm } from "./BasicInfoForm";
import { VenueOwnerProfileForm } from "./VenueOwnerProfileForm";
import { PromoterProfileForm } from "./PromoterProfileForm";
import { PerformerProfileForm } from "./PerformerProfileForm";
import { SecuritySettingsForm } from "./SecuritySettingsForm";
import { SocialLinksForm } from "./SocialLinksForm";
import { NotificationPreferences as NotificationPreferencesComponent } from "./NotificationPreferences";
import { ProfileTabsProps } from "./types";
import { RoleType } from "@/types/profile";

export const ProfileTabs = ({ profile, register, watch, setValue }: ProfileTabsProps) => {
  const isPerformer = (profile.role_types || []).some(role => 
    ['DJ', 'Drag Queen'].includes(role)
  );

  return (
    <Tabs defaultValue="basic" className="w-full">
      <TabsList className="w-full justify-start">
        <TabsTrigger value="basic">Basic Info</TabsTrigger>
        <TabsTrigger value="notifications">Notifications</TabsTrigger>
        {profile.role_types?.includes('Venue Owner') && (
          <TabsTrigger value="venue">Venue Details</TabsTrigger>
        )}
        {profile.role_types?.includes('Promoter') && (
          <TabsTrigger value="promoter">Promoter Info</TabsTrigger>
        )}
        {isPerformer && (
          <TabsTrigger value="performer">Performer Profile</TabsTrigger>
        )}
        <TabsTrigger value="social">Social Links</TabsTrigger>
        <TabsTrigger value="security">Security</TabsTrigger>
      </TabsList>

      <div className="mt-6 space-y-6">
        <TabsContent value="basic">
          <BasicInfoForm register={register} />
        </TabsContent>

        <TabsContent value="notifications">
          <NotificationPreferencesComponent
            preferences={watch('notification_preferences')}
            onChange={(prefs) => setValue('notification_preferences', prefs)}
          />
        </TabsContent>

        <TabsContent value="venue">
          <VenueOwnerProfileForm register={register} watch={watch} setValue={setValue} />
        </TabsContent>

        <TabsContent value="promoter">
          <PromoterProfileForm register={register} />
        </TabsContent>

        <TabsContent value="performer">
          <PerformerProfileForm register={register} />
        </TabsContent>

        <TabsContent value="social">
          <SocialLinksForm register={register} />
        </TabsContent>

        <TabsContent value="security">
          <SecuritySettingsForm register={register} profile={profile} />
        </TabsContent>
      </div>
    </Tabs>
  );
};
